/* eslint-disable no-debugger */
import { ageRangeErrors } from '../shared/ReportFilterValidation';

export const localValidate = (formState) => {
  let errors = { ...ageRangeErrors(formState) };

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Organization is required';
  }

  if (formState.genders.length === 0) {
    errors.genders = 'At least one competition category must be selected';
  }

  return errors;
};

const ImxDetailReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ImxDetailReportValidation;